/*
 * set all tabindex to zero
 * https://dequeuniversity.com/rules/axe/4.8/tabindex?application=AxeChrome
 */
const IVUFixTabIndex = () => {
    console.log("fixing tabindex");
    jQuery('[tabindex]:not([tabindex="0"]):not([tabindex="-1"])').attr(
        "tabindex",
        "0"
    );
};

jQuery(document).ready(function () {
    IVUFixTabIndex();
});
